export default function ProgressBar({ percent, color = 'green' }: { percent: number; color?: string }) {
  return (
    <>
      <div className="w-full bg-gray-200 h-1">
        <div className={`bg-${color}-600 h-1 w-full`} style={{ width: `${percent}%` }}></div>
      </div>
    </>
  );
}
